import { useState } from "react";

export type ToastTone = "success" | "warning" | "error";

export interface ActionToast {
  readonly tone: ToastTone;
  readonly message: string;
}

/** The single inline toast of the user detail page (one at a time; the next replaces it). */
export function useUserActionToast() {
  const [toast, setToast] = useState<ActionToast | null>(null);
  return { toast, setToast };
}
